export default __webpack_public_path__ + "static/2263-0290d21906ca037f1c9768fa15178f3c.gif";